var magicStyles = [".checkboxes[data-v-3e8c346a]{margin:0 auto var(--magic-space,16px)}.checkbox[data-v-3e8c346a]{display:block;margin:var(--magic-space--large,32px) 0}.checkbox[data-v-3e8c346a]:first-child{margin-top:var(--magic-space,16px)}"];

export default magicStyles;
